/**
 * App.js Layout Start Here
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import * as Sentry from "@sentry/browser";
import { Switch, Redirect, Route } from "react-router-dom";
import { NotificationContainer } from "react-notifications";

// rct theme provider
import RctThemeProvider from "./RctThemeProvider";

//Main App
import RctDefaultLayout from "./DefaultLayout";

// app signin
import SigninCognito from "./SigninCognito";
import StartingNewPassword from "../components/Auth/StartingNewPassword";

/**
 * Initial Path To Check Whether User Is Logged In Or Not
 */
const InitialPath = ({ component: Component, authUser, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (authUser) {
        return <Component {...props} />;
      } else {
        if (props.location.pathname.length > 4) {
          localStorage.setItem("REDIRECT", props.location.pathname);
        }
        return (
          <Redirect
            to={{
              pathname: "/signin",
              state: { from: props.location }
            }}
          />
        );
      }
    }}
  />
);

class App extends Component {
  constructor(props) {
    super(props);
    this.signIn = this.signIn.bind(this);
  }
  componentDidMount() {
    console.log("USER PROPS", this.props);
    console.log("APP.env", process.env.REACT_APP_STAGE);
    if (
      process.env.REACT_APP_STAGE === "dev" ||
      process.env.REACT_APP_STAGE === "prod"
    ) {
      // this.enableProductionLog();
    }
  }
  enableProductionLog() {
    var console = {};
    console.log = function(e) {
      // if (e.indexOf("QA") > -1) {
      //   originalLogger.log(e);
      // }
      if (typeof e === "string") {
        const arrVal = e;
        if (arrVal.indexOf("QA WOLF TEST") > -1) {
          let testArr = arrVal.split(" ");
          let testName = testArr[testArr.length - 1];
          Sentry.setTag("testName", testName);
        }
      }
    };
    console.info = function() {};
    console.warn = function() {};
    console.error = function() {};
    window.console = console;
  }
  signIn() {
    return (
      <SigninCognito
        stage={process.env.REACT_APP_STAGE}
        history={this.props.history}
      />
    );
  }
  render() {
    const { location, match, user } = this.props;
    if (location.pathname === "/") {
      if (user === null) {
        return <Redirect to={"/signin"} />;
      } else {
        return <Redirect to={"/app/dashboard"} />;
      }
    }
    return (
      <RctThemeProvider>
        <NotificationContainer />
        <Switch>
          <InitialPath
            path={`${match.url}app`}
            authUser={user}
            component={RctDefaultLayout}
          /> 
          <Route path="/signin" component={this.signIn} />
          <Route path="/starting" component={StartingNewPassword} />
          {/* <Route
            path="/session/forgot-password"
            component={AsyncSessionForgotPasswordComponent}
          />
          <Route
            path="/terms-conditions"
            component={AsyncTermsConditionsComponent}
          /> */}
        </Switch>
      </RctThemeProvider>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser }) => {
  const { user } = authUser;
  return { user };
};

export default connect(mapStateToProps)(App);
